/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MaterialReactTable } from "material-react-table";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, postData, putData } from "utils/Gateway"; // add putData import

// reuse existing header used for offers (keeps UI consistent)
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import CustomerPriceListHeader from "./Header/CustomerPriceListHeader";
import CommonHeader from "../MarketplaceHeader/CommonHeader";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import CustomerPriceListFilterPopup from "./Popup/CustomerPriceListFilterPopup";
import { replaceListByIds } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";

const CustomerPriceListBody = () => {
  const { t } = useTranslation();

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [customerPricings, setCustomerPricings] = useState([]);
  const [loading, setLoading] = useState(false);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedCustomerPricingIds, setSelectedCustomerPricingIds] = useState(
    []
  );
  const [selectedCustomerPricingId, setSelectedCustomerPricingId] =
    useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  // Add filter state
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);

  // fetch all customer pricings
  const getAllCustomerPricings = async () => {
    try {
      setLoading(true);
      const requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_CUSTOMER_PRICINGS +
        `?token=${token}`;
      console.log("requestUrl in customer pricing list------->", requestUrl);
      const response = await getData(requestUrl);
      console.log("response in customer pricing list------->", response);
      setLoading(false);
      if (response.status) {
        setCustomerPricings(response.data);
        setMessageType("success");
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
      setShowAlert(true);
    } catch (error) {
      setLoading(false);
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  // Dummy API call for filter (replace with real API)
  const getFilteredCustomerPricings = async () => {
    try {
      setLoading(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_FILTERED_CUSTOMER_PRICINGS +
        `?token=${token}`;

      console.log("Original jsonFilterQuery:", jsonFilterQuery);

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        filters: sanitizedQuery,
      };

      const response = await postData(requestUrl, filterData);

      console.log("json filter query response ------->", response);

      if (response.status) {
        setMessageType("success");
        setCustomerPricings(response.data);
      } else {
        setMessageType("error");
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  const bulkUpdateCustomerPricing = async () => {
    if (selectedCustomerPricingIds.length === 0) {
      setMessageType("error");
      setAlertMessage("Please select at least one customer pricing");
      setShowAlert(true);
      return;
    }
    try {
      const listToBeUpdated = customerPricings.filter((item) =>
        selectedCustomerPricingIds.includes(item._id)
      );
      const apiData = { pricings: listToBeUpdated };
      const requestURL =
        url.API_BASE_URL +
        url.API_BULK_UPDATE_PRODUCT_CUSTOMER_PRICING +
        `?token=${token}`;
      const response = await putData(requestURL, apiData);
      if (response.status) {
        setMessageType("success");
        setAlertMessage(response.message);
        setTimeout(() => {
          setRowSelection({});
          setSelectedCustomerPricingIds([]);
        }, 1500);
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
    }
    setShowAlert(true);
  };

  const bulkDeleteCustomerPricing = async () => {
    if (selectedCustomerPricingIds.length === 0) {
      setMessageType("error");
      setAlertMessage("Please select at least one customer pricing");
      setShowAlert(true);
      return;
    }
    try {
      const listToBeDeleted = customerPricings.filter((item) =>
        selectedCustomerPricingIds.includes(item._id)
      );
      const apiData = { pricings: listToBeDeleted };
      const requestURL =
        url.API_BASE_URL +
        url.API_BULK_DELETE_PRODUCT_CUSTOMER_PRICING +
        `?token=${token}`;
      const response = await putData(requestURL, apiData);
      if (response.status) {
        setMessageType("success");
        setAlertMessage(response.message);
        setTimeout(() => {
          setCustomerPricings((prevList) =>
            prevList.filter(
              (item) => !selectedCustomerPricingIds.includes(item._id)
            )
          );
          setRowSelection({});
          setSelectedCustomerPricingIds([]);
        }, 1500);
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
    }
    setShowAlert(true);
  };

  const removeTagFromCustomerPricing = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_PRODUCT_CUSTOMER_PRICING;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setCustomerPricings((prev) => replaceListByIds(prev, data));
    }, 1000);
  };

  // Watch for filter changes and call dummy API
  useEffect(() => {
    if (jsonFilterQuery && jsonFilterQuery.length > 0) {
      getFilteredCustomerPricings();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      setIsFilterReset(true);
      getAllCustomerPricings();
      setReloadData(false);
    }
  }, [reloadData]);

  useEffect(() => {
    getAllCustomerPricings();
  }, []);

  const formatDateForInput = (isoDate) => {
    if (!isoDate) return "";
    // Accepts ISO string, returns YYYY-MM-DD
    return isoDate.slice(0, 10);
  };

  const handleCellChange = (rowIndex, key, value) => {
    setCustomerPricings((prev) => {
      const updated = [...prev];
      if (key === "startdate" || key === "enddate") {
        // Convert to ISO format with zero time
        updated[rowIndex][key] = new Date(value).toISOString();
      } else {
        updated[rowIndex][key] = value;
      }
      return updated;
    });
  };

  const columns = useMemo(
    () => [
      // {
      //   accessorKey: "#",
      //   header: t("Actions"),
      //   size: 50,
      //   Cell: ({ row }) => (
      //     <button className="action_btn_mui">
      //       <span className="d-block material-symbols-outlined horz_icon">
      //         more_horiz
      //       </span>
      //     </button>
      //   ),
      //   enableColumnActions: false, // Hides the column action icon
      //   enableColumnDragging: false, // Hides the move icon
      //   enableSorting: false,
      // },
      {
        accessorKey: "productname",
        header: t("Product"),
      },
      {
        accessorKey: "productimage",
        header: "Image",
        Cell: ({ cell, row }) => {
          return (
            <img
              className="rounded"
              src={url.SERVER_URL + row.original.productimage}
              alt="Product"
              style={{ width: 50, height: 50 }}
            />
          );
        },
      },
      //tags
      {
        accessorKey: "tagstring",
        header: t("Tags"),
        Cell: ({ row }) => (
          <div className="label-wrapper py-1">
            <div className="d-flex gap-2">
              <div
                className={
                  row.original.tags.length > 0
                    ? "label-container flex-grow-1"
                    : "d-none"
                }
              >
                <ul
                  className="d-flex flex-wrap gap-2 m-0 p-0"
                  style={{ listStyle: "none" }}
                >
                  {row.original.tags &&
                    row.original.tags.map((tag, index) => (
                      <li key={index} className="d-inline-flex">
                        <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                          <span className="badge-text fs-xs fw-medium me-1">
                            {tag.title}
                          </span>
                          <Link
                            to="#"
                            className={`${
                              tag.moderator.toString() ===
                                userInfo._id.toString() ||
                              userInfo.role.slug === "ADMIN" ||
                              userInfo.role.slug === "SUPER_ADMIN"
                                ? "d-block"
                                : "d-none"
                            }`}
                            onClick={() => {
                              setSelectedTagId(tag._id);
                              setSelectedCustomerPricingId(row.original._id);
                              removeTagFromCustomerPricing(
                                [tag._id],
                                row.original._id
                              );
                            }}
                          >
                            {selectedTagId &&
                            selectedTagId === tag._id &&
                            selectedCustomerPricingId &&
                            selectedCustomerPricingId === row.original._id ? (
                              <div
                                className="spinner-border spinner-border-sm text-primary ms-1"
                                role="status"
                                style={{ height: "12px", width: "12px" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            ) : (
                              <span
                                className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                                style={{ cursor: "pointer" }}
                              >
                                cancel
                              </span>
                            )}
                          </Link>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
              <button
                className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
                style={{ width: "24px", height: "24px" }}
                data-bs-toggle="modal"
                data-bs-target="#addLabelModal"
                onClick={() =>
                  setSelectedCustomerPricingIds([row.original._id])
                }
              >
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "16px" }}
                >
                  add
                </span>
              </button>
            </div>
          </div>
        ),
      },
      {
        accessorKey: "companyname",
        header: t("Company"),
      },
      {
        accessorKey: "price",
        header: t("Price"),
        Cell: ({ row, cell }) => (
          <input
            type="number"
            className="form-control fs-sm bg-white py-2 border-gray-300 shadow-none"
            style={{ width: "100%" }}
            value={row.original.price}
            onChange={(e) =>
              handleCellChange(row.index, "price", e.target.value)
            }
          />
        ),
      },
      {
        accessorKey: "pricingstartdate",
        header: t("Valid From"),
        Cell: ({ row, cell }) => (
          <input
            type="date"
            className="form-control fs-sm bg-white py-2 border-gray-300 shadow-none"
            style={{ width: "100%" }}
            value={formatDateForInput(row.original.startdate)}
            onChange={(e) =>
              handleCellChange(row.index, "startdate", e.target.value)
            }
          />
        ),
      },
      {
        accessorKey: "pricingenddate",
        header: t("Valid To"),
        Cell: ({ row, cell }) => (
          <input
            type="date"
            className="form-control fs-sm bg-white py-2 border-gray-300 shadow-none"
            style={{ width: "100%" }}
            value={formatDateForInput(row.original.enddate)}
            onChange={(e) =>
              handleCellChange(row.index, "enddate", e.target.value)
            }
          />
        ),
      },
      {
        accessorKey: "createddate",
        header: t("Created Date"),
      },
    ],
    [customerPricings, selectedTagId, selectedCustomerPricingId]
  );

  const initialColumnOrder = [
    // "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    if (selectedIdsArray.length > 0) {
      setSelectedCustomerPricingIds(selectedIdsArray);
    } else {
      setSelectedCustomerPricingIds([]);
    }
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  return (
    <div id="content_wrapper">
      <section className="marketplace-wrapper bg-white">
        <CommonHeader activeOption="Customer Pricing" />

        <div className="container-fluid px-lg-5">
          <CustomerPriceListHeader
            reloadList={getAllCustomerPricings}
            selectedCustomerIds={selectedCustomerPricingIds}
            bulkUpdateHandler={bulkUpdateCustomerPricing}
          />

          {/* table */}
          {loading ? (
            <LoadingSkeleton />
          ) : (
            <div className="table-wrapper">
              <MaterialReactTable
                columns={columns}
                data={customerPricings}
                enableRowSelection
                getRowId={(row) => row._id}
                onRowSelectionChange={setRowSelection}
                state={{ rowSelection, columnOrder: initialColumnOrder }}
                initialState={{ rowSelection, columnOrder: initialColumnOrder }}
                defaultColumn={{ minSize: 20, maxSize: 300, size: 50 }}
                muiTableContainerProps={{ sx: { maxHeight: "60vh" } }}
                enableStickyHeader
              />
            </div>
          )}
        </div>
      </section>

      {/* Filter Popup */}
      <CustomerPriceListFilterPopup
        isFilterReset={isFilterReset}
        setIsFilterReset={setIsFilterReset}
        setJsonFilterQuery={setJsonFilterQuery}
        reloadList={getAllCustomerPricings}
        moduleSlug="productcustomerpricing"
      />

      <AddLabelModal
        moduleName="productcustomerpricing"
        selectedIds={selectedCustomerPricingIds}
        afterTagModalClose={afterModalActionClose}
        setShowAlert={setShowAlert}
        setAlertMessage={setAlertMessage}
        setMessageType={setMessageType}
        onModalClose={() => {
          setSelectedCustomerPricingIds([]);
          setRowSelection({});
        }}
      />

      <DeleteWarningModal
        onCancelDelete={() => {
          setRowSelection({});
          setSelectedCustomerPricingIds([]);
        }}
        onDelete={bulkDeleteCustomerPricing}
        moduleName={t("Customer pricing")}
      />

      {showAlert && (
        <AlertNotification
          showAlert={showAlert}
          message={alertMessage}
          alertType={messageType}
          onClose={onAlertClose}
        />
      )}
    </div>
  );
};

export default CustomerPriceListBody;
